import Swiper, { Navigation, Pagination, Lazy } from 'swiper';

export default class Sliders
{
    constructor ( sliderContainer )
    {


        this.sliderContainer       = sliderContainer;
        this.sliderContainerParent = this.sliderContainer.parentElement;
        this.swiperPagination      = this.sliderContainerParent.querySelector( '.swiper-pagination' );


        this.isBirthdaySlider = this.sliderContainer.classList.contains( 'birthdays-swiper' );

        Swiper.use( [ Navigation, Pagination, Lazy ] );

        sliderContainer.classList.add( 'swiper' );

        const numSlides = this.sliderContainer.querySelectorAll( '.swiper-slide' ).length;
        if ( numSlides < 2 )
        {
            // a one-slide slider won't be fun for anyone
            return;
        }

        this.setupSwiper()
    }


    setupSwiper ()
    {

        // console.log( 'Found swiper element', element );


        const swiperOptions = {
            // autoHeight: true,


            // Disable preloading of all images
            preloadImages : false,

            // Enable lazy loading
            lazy : {
                loadPrevNext : true,
                enabled      : true,
            },

            loop : true,


        }

        // not all sliders have bullets/pagination in this project


        if ( this.swiperPagination )
        {
            swiperOptions[ 'pagination' ] = {
                el   : '.swiper-pagination',
                type : 'bullets',
            };
        }


        if ( this.sliderContainer.classList.contains( 'keywords-swiper' ) )
        {

            const parentContainer = this.sliderContainer.closest( '.keywords-menu' );
            const prev            = parentContainer.querySelector( '.swiper-button-prev' );
            const next            = parentContainer.querySelector( '.swiper-button-next' );


            swiperOptions.navigation = {
                prevEl : prev,
                nextEl : next,
            };

            swiperOptions.loop          = false;
            swiperOptions.slidesPerView = 'auto';

        } else if ( this.sliderContainer.classList.contains( 'has-navigation' ) )
        {
            if ( typeof swiperOptions.navigation === 'undefined' )
            {
                swiperOptions.navigation = {};
            }

            this.btnNext = this.sliderContainerParent.querySelector( '.swiper-button-next' );
            this.btnPrev = this.sliderContainerParent.querySelector( '.swiper-button-prev' );

            console.log( 'BUTTONS', this.btnPrev, this.btnNext )

            swiperOptions.navigation.nextEl = this.btnNext;
            swiperOptions.navigation.prevEl = this.btnPrev;

            // swiperOptions.navigation.nextEl = '.swiper-button-next';
            // swiperOptions.navigation.prevEl = '.swiper-button-prev';


            this.maybeFindBtns();

            swiperOptions.on = {
                'init'   : this.adjustNavHeight,
                'update' : this.adjustNavHeight,
                'resize' : this.adjustNavHeight,
            };
        }


        if ( this.sliderContainer.classList.contains( 'no-loop' ) )
        {
            swiperOptions.loop = false;
        }


        if ( this.isBirthdaySlider )
        {

            swiperOptions.shortSwipes    = false;
            swiperOptions.allowTouchMove = false;
            swiperOptions.preventClicks  = false;
        }

        console.log( 'swiperOptions', swiperOptions )

        this.swiperInstance = new Swiper( this.sliderContainer, swiperOptions );
    }

    maybeFindBtns ()
    {
        const parent = this.sliderContainer.closest( '.block-slider' );

        if ( !parent )
        {
            return;
        }

        this.btnPrev = parent.querySelector( '.swiper-navigation .swiper-button-prev' );
        this.btnNext = parent.querySelector( '.swiper-navigation .swiper-button-next' );

    }

    adjustNavHeight ()
    {

        if ( !this.swiperInstance )
        {
            return;
        }

        const firstSlide      = this.swiperInstance.slides[ 0 ];
        const firstSlideImage = firstSlide.querySelector( '.image-container' );


        if ( !firstSlideImage )
        {
            return;
        }

        const slideHeight = firstSlideImage.getBoundingClientRect().height;


        this.btnPrev.style.top = Math.floor( slideHeight / 2 ) + "px";
        this.btnNext.style.top = Math.floor( slideHeight / 2 ) + "px";

    }
}

